/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {

    "use strict";


    export class GridConfiguration {

        public static $inject : string[ ] = [
           '$scope',
            'controller',
            '$q',
            '$timeout',
            'i18nService',
            'uiGridExporterConstants',
            'uiGridExporterService'
        ];

        // Last time, I promise!
        public config               : any = { };
        public handlersRegistered   : boolean = false;


        constructor(
            public $scope                   : ng.IScope,
            public controller               : any,
            public $q                       : ng.IQService,
            public $timeout                 : ng.ITimeoutService,
            public i18nService              : any,
            public uiGridExporterService    : any,
            public uiGridExporterConstants  : any
        ) {

            var that = this;

            this.config = {
                exporterCsvFilename         : 'records_download.csv',
                exporterMenuPdf             : false,
                exporterMenuCsv             : true,
                exporterCsvLinkElement      : angular.element(document.querySelectorAll(".custom-csv-link-location")),

                gridMenuCustomItems: [
                    {
                        icon: 'ui-grid-icon-cancel',
                        title: 'Clear ALL filters',
                        action: function () {

                            if (that.controller.onClearFilter && that.controller.parentControllerAs) {
                                that.controller.onClearFilter.call (
                                    that.controller.findParentController ($scope, that.controller.parentControllerAs)
                                );
                            }
                            else {
                                that.$scope.$root.$broadcast('clearFilter');
                            }
                        },

                        order: 299
                    }
                ],

                // Copied into config.gridMenuCustomItems if that.controller.csvExport exists.
                //
                gridMenuCustomItemsConfiguration: [
                    {
                        icon: 'fa fa-file-excel-o',
                        title: 'Download these records as CSV',
                        action: function () {

                            var config = that.controller.csvExport;

                            if (! config || ! config.thisPage) {
                                that.controller.gridApi.exporter.csvExport(
                                    'all',
                                    'visible',
                                    that.config.exporterCsvLinkElement
                                );
                            }
                            else {
                                that.$timeout(function () {
                                    angular.element(document.getElementById('csvExportThisPage'))
                                        .trigger('click');
                                });
                            }
                        },

                        order: 299
                    },
                    {
                        icon: 'fa fa-file-excel-o',
                        title: 'Download ALL records as CSV',
                        action: function () {

                            var config = that.controller.csvExport;

                            if (! config || ! config.allPages) {
                                that.controller.gridApi.exporter.csvExport(
                                    'all',
                                    'all',
                                    that.config.exporterCsvLinkElement
                                );
                            }

                            // Ng-csv provides an easy way to convert JSON to CSV for export/download, but
                            // its limitation is its expectation is that it'll be implemented on a button
                            // or other clickable element -- so ng-csv's export code fires off when the directive's
                            // element is clicked.  But we can't directly add the ng-csv attribute to the grid's
                            // hamburger menu action buttons because the grid creates those elements.
                            //
                            // So anybody who ever had to implement a file upload button via <input type="file" ... />,
                            // but provide a look for the button that's consistent with other, normal buttons in
                            // the interface, and doesn't look like ass as the default control does, will be familiar
                            // with the programatically-clicking-a-hidden-button trick.
                            //
                            // (and we have to wait for the $digest cycle to finish before we can interact with
                            // this control's events, hence the $timeout)
                            //
                            else {
                                that.$timeout(function() {
                                    angular.element(document.getElementById('csvExportAllPages'))
                                        .trigger('click');
                                });
                            }
                        },

                        order: 299
                    }
                ],

                enableGridMenu              : true,
                enableSelectAll             : true,
                enableRowHeaderSelection    : true,
                enableRowSelection          : true,
                rowHeight                   : 49,

                minRowsToShow               : 5,
                maxRowsToShow               : 50,

                enableHorizontalScrollbar   : 1,
                enableVerticalScrollbar     : 1,
                enableColumnResizing        : 1,
                enableColumnMoving          : 1,

                enableFiltering             : false,
                useExternalFiltering        : false,

                enableSorting               : true,
                useExternalSorting          : false,

                onRegisterApi: function (gridApi : any) {

                    that.controller.gridApi = gridApi;

                    // Re: clearExternalFilters is a flag (for any controller using the grid) as a signal
                    // that filters set external to the grid should be cleared, in addition to grid filters
                    // which get cleared by the grid and its controller.
                    //
                    var changeSortOrFilter = ( callback: any, sortColumns: any[], clearFilters: boolean ) => {

                        var filters: any = { };
                        if (clearFilters) {
                            filters._deleteAll = true;
                        }
                        else {
                            filters = that.controller.calculateFilter (gridApi.grid.columns);
                        }

                        callback.call (
                            that.controller.findParentController ($scope, parentControllerAs),
                            sortColumns,
                            filters
                        )
                    };

                    // This function and the next can be invoked by user action on the column sort
                    // and filter controls, or programatically, via $broadcast-ing events.
                    //
                    var changeSort = ( e: ng.IAngularEvent, sortColumns: any[] ) => {
                        if (that.controller.onSort) {
                            changeSortOrFilter (that.controller.onSort, sortColumns, false);
                        }
                    };

                    var clearSort = ( ) => {
                        changeSort (undefined, [ ]);
                    };

                    var changeFilter = ( e: ng.IAngularEvent, clearFilters?: boolean ) => {
                        if (that.controller.onFilter) {
                            changeSortOrFilter (that.controller.onFilter, null, clearFilters);
                        }
                    };

                    var clearSortAndFilterCallbackData = ( ) => {
                        if (that.controller.onClearSortAndFilter) {
                            changeSortOrFilter (that.controller.onClearSortAndFilter, [ ], true);
                        }
                    };

                    // Returns whether or not there was a filter to clear.
                    //
                    var clearFilter = ( ) => {

                        //The date/time/numeric filters can't be reset without the parentControllerAs.
                        //
                        var parentControllerAs = that.controller.parentControllerAs;
                        if (parentControllerAs) {

                            var parentController = that.controller.findParentController(
                                that.$scope, that.controller.parentControllerAs
                            );

                            // Remove the state data inside filter modals, so that when next opened, they'll
                            // have reverted to default parameter data.
                            //
                            var modalFilterSet = false;
                            Object.keys(parentController.filterControlData).forEach( ( filterField: string ) => {

                                if (parentController.filterControlData[filterField].gridColumn.modalData !== undefined) {
                                    modalFilterSet = true;
                                    delete parentController.filterControlData[filterField].gridColumn.modalData;
                                }
                            });

                            // Now that the modal filters have been cleared manually, it would really be nice to just call
                            // the grid's built-in clearAllFilters() method, but it won't do anything, including
                            // reloading the data, unless one of the built-in text filter fields has an entered value.
                            //
                            // So in the case where none do, manually fire off our data load if no text filters
                            // have been set
                            //
                            if ( that.controller.gridApi.grid.columns.some ( ( column: any ) => {
                                    return column.filters.some ( ( filter: any ) => {
                                        if (filter.term !== '' && filter.term !== undefined) {
                                            return true;
                                        }
                                    });
                                })
                            ) {
                                that.controller.gridApi.core.clearAllFilters();
                                if (doClearSortAndFilter()) {
                                    clearSortAndFilterCallbackData();
                                }
                                else {
                                    changeFilter (undefined, true);
                                }
                            }
                            // No built-in text filters have been input by the user, but a modal filter has been
                            // applied.  We might also need to clear the sorts if directed to from the
                            // clearSortAndFilter event.
                            //
                            else if (modalFilterSet) {
                                // Unless we're doing a full filter/sort reset, then just reset the filter.
                                //
                                if (! doClearSortAndFilter()) {
                                    changeFilter (undefined, true);
                                }
                            }
                            else {
                                // This is a full refresh of the data.
                                //
                                clearSortAndFilterCallbackData ();
                            }
                        }
                    };

                    var clearSortAndFilter = ( ) => {

                        // Difficult: that.controller.doClearSort.
                        //
                        // The filter methods need to know that a full filter/sort clear has been ordered,
                        // so that they don't simply reset the filtering only.  So a yucky state variable
                        // was added.
                        //
                        that.controller.doClearSort = true;

                        clearFilter ();
                    };

                    var doClearSortAndFilter = ( ) => {

                        // Do full filter and sort clear, if directed to do so from the clearSortAndFilter event.
                        //
                        if (that.controller.doClearSort) {

                            // Reset sorts to default if this filterChanged grid event was called from
                            // clearSortAndFilter, which is done by passing an empty array as sortColumns.
                            // In reports.ts, this resets sorts to page defaults.
                            //
                            changeSortOrFilter (that.controller.onClearSortAndFilter, [ ], true);

                            // Sort/filter clearing finished, so restore state to original.
                            //
                            that.controller.doClearSort = false;

                            return true;
                        }
                    };

                    gridApi.core.on.rowsRendered(that.$scope, (api : any) => {
                        that.controller.loading = false;

                        if (! that.handlersRegistered) {
                            that.$scope.$root.$on('changeFilter', changeFilter);
                            that.$scope.$root.$on('clearFilter', clearFilter);
                            that.$scope.$root.$on('changeSort', changeSort);
                            that.$scope.$root.$on('clearSort', clearSort);
                            that.$scope.$root.$on('clearSortAndFilter', clearSortAndFilter);
                            that.handlersRegistered = true;
                        }
                    });

                    gridApi.core.on.sortChanged( $scope, ( grid: any, sortColumns: any[] ) => {
                        while (sortColumns.length > 1) {
                            sortColumns[0].unsort();
                            sortColumns.shift();
                        }
                    });

                    // onSort and onFilter callbacks need to be scoped to their controller,
                    // so if parentControllerAs isn't provided, so don't set up custom sort/filter
                    // events.
                    //
                    var parentControllerAs = that.controller.parentControllerAs;
                    if (! parentControllerAs) {
                        return;
                    }

                    // Call onSort function passed in by parent controller.
                    //
                    gridApi.core.on.sortChanged($scope, ( grid: any, sortColumns: any[] ) => {
                        if (that.controller.onSort) {
                            changeSort (undefined, sortColumns);
                        }
                    });

                    gridApi.core.on.renderingComplete($scope, function() {

                        $scope.$watchCollection(( ) => {
                            return angular.element('.ui-grid-menu').scope()
                                && (<any>angular.element('.ui-grid-menu').scope()).menuItems
                        }, function(menuItems) {

                            if (menuItems && menuItems.length) {
                                var menuElement = angular.element('.ui-grid-menu');

                                // Fucked up repugnant shit.  Seemingly, the only way to hide column visibility menu
                                // items directly in the grid component.  The chicanery necessary to do it post hoc,
                                // i.e. after the results have already been generated, in the reports controller itself
                                // seems even less desirable.
                                //
                                // Getting rid of the pre-generated grid menu items this way allows the column
                                // definitions to be clear and simple in the case where it's necessary to hide a column
                                // on the reports page (and perforce from the show columns menu) but show it in the
                                // exported .csv, like time zones.
                                //
                                (<any>menuElement).scope().menuItems = (<any>menuElement).scope().menuItems.filter(
                                    ( item: any ) => {
                                        return item.context ?
                                            ! item.context.gridCol.colDef.hideColumnVisibilityMenuItem : true;
                                    }
                                );
                            }
                        })
                    });

                    // Call onFilter function passed in by parent controller.  This thing can get called
                    // multiple times, e.g. on clicking the 'X' to blank out a set text filter.
                    // Too bad so sad.  Setting some kind of filterChangeInProgress state variable is
                    // just not worth it.  Just need to make sure that when the filter calculation
                    // code in setFilters is run, it can safely be run twice without fucking up the filters.
                    //
                    // Big problem is, it also fires off the XHR twice.  Borderline somewhat unacceptable.
                    //
                    gridApi.core.on.filterChanged( $scope, ( ) => {

                        // Unless we're doing a full filter/sort reset, then just reset the filter.
                        //
                        if (! doClearSortAndFilter()) {
                            changeFilter (undefined, false);
                        }
                    });
                },

                exporterFieldCallback: function ( grid : any, row : any, col : any, value : any ) {
                    // I'm not sure this gets called on any export event.
                    //
                    return that.controller.calculateCsvValue (value, row, col);
                }
            };
        }
    }

    getDealerwareWebComponentsModule().controller('gridConfiguration', GridConfiguration);


    export class UiGridDirectiveController {

        public static $inject: string[] = [
            '$scope',
            '$timeout',
            '$q',
            'i18nService',
            '$controller'
        ];

        public collection               : any        = {
            data: [ ]
        };
        public list                     : any        = [ ];

        public columns                  : any        = [ ];
        public loading                  : any        = true;
        public error                    : any        = false;
        public mapping                  : any        = { };
        public enableFiltering          : boolean    = false;
        public serverSidePageSortFilter : boolean    = false;
        public onSort                   : any;
        public onFilter                 : any;
        public onClearSortAndFilter     : any;
        public onClearFilter            : any;
        public csvExport                : any;
        public pager                    : any;

        public parentControllerAs       : any;
        public render                   : boolean    = false;
        public noDataInitMessage        : string     = 'Please select a search criterion.';
        public noDataEmptyMessage       : string     = 'No records found.';
        public errorMessage             : string     = 'An error occurred loading data.';
        public showCollapseExpandButton : boolean    = false;
        public initialCollapse          : boolean    = true
        public gridCollapsed            : boolean    = true;
        public collapseExpandItemCount  : number;

        public dataMap                  : any        = { };
        public gridColumnOrderedKeys    : any        = [ ];
        public gridOptions              : any        = { };
        public gridApi                  : any;
        public gridConfiguration        : any;
        public searchInitTemplate       : string     = 'dealerware-ui-grid/search-init';
        public gridContent              : string     = this.searchInitTemplate;

        public initialized              : boolean    = false;
        public doClearSort             : boolean    = false;


        constructor (
            public $scope               : any,
            public $timeout             : any,
            public $q                   : any,
            public i18nService          : any,
            public $controller          : any
        ) {

            this.setCurrentLanguage();
            this.gridConfiguration = $controller('gridConfiguration',
                { '$scope': this.$scope, controller: this }
            ).config;

            // Create custom CSV menu items if controller instantiating ui-grid sent over
            // CSV configuration.  One or both of This Page or All Pages CSV export configs
            // may have been given.
            //
            if (this.csvExport) {

                this.gridConfiguration.exporterMenuCsv = false;

                if (this.csvExport.showExporterMenu) {
                    if (this.csvExport.thisPage) {
                        this.gridConfiguration.gridMenuCustomItems.push(
                            this.gridConfiguration.gridMenuCustomItemsConfiguration[0]
                        );
                    }

                    if (this.csvExport.allPages) {
                        this.gridConfiguration.gridMenuCustomItems.push(
                            this.gridConfiguration.gridMenuCustomItemsConfiguration[1]
                        );
                    }
                }
            }

            this.installWatchers();
        }

        private setCurrentLanguage(): void {
            const language = localStorage.getItem('language');
            const isSupportedLanguage = this.i18nService.getAllLangs().includes(language)
            if (isSupportedLanguage) {
                this.i18nService.setCurrentLang(language);
                return;
            }
            this.i18nService.setCurrentLang('en');
        }

        private installWatchers () : void {

            var that = this;

            // Shows loading spinny template, or else the loading watcher was just initialized
            // by the parent controller and instaed and show the grid in beginning state.
            //
            this.$scope.$watch( ( ) => {
                return that.loading;
            }, ( loading: any ) => {
                if (loading) {
                    that.setGridOptionsForLoading();
                }
            });

            // Either a Collection of objects whose data attribute contains the actual,
            // object/model data, or a generic array of objects, can be used
            // to populate the grid but to use th deealerwareCollectionListPager
            // directive, the former is required.
            //
            this.$scope.$watch( ( ) => {
                return that.collection.data;
            }, ( gridList: any ) => {
                that.error = false;
                that.toggleResultsExpansion();
                that.showCollapseExpandButton = !! (
                    this.collapseExpandItemCount &&
                    this.collection.data &&
                    this.collection.data.length > this.collapseExpandItemCount
                );

            });

            this.$scope.$watch( ( ) => {
                return that.list;
            }, ( gridList: any ) => {
                that.error = false;
                that.initializeGridResults (gridList);
            });

            // Bubble up the error.
            //
            this.$scope.$watch( ( ) => {
                return that.error;
            }, ( error: any ) => {
                if (error) {
                    that.setGridOptionsForError();
                }
            });

            var unwatchSetters: any = { };

            unwatchSetters['serverSidePageSortFilter'] = this.$scope.$watch( ( ) => {
                return that.serverSidePageSortFilter;
            }, ( enable: boolean ) => {
                if (enable) {
                    that.gridConfiguration.useExternalSorting = enable;
                    that.gridConfiguration.useExternalFiltering = enable;
                    unwatchSetters['serverSidePageSortFilter'] ();
                }
            });

            unwatchSetters['enableFiltering'] = this.$scope.$watch( ( ) => {
                return that.enableFiltering;
            }, ( enable: boolean ) => {
                if (enable) {
                    that.gridConfiguration.enableFiltering = enable;
                    unwatchSetters['enableFiltering'] ();
                }
            });

            // Create columns map so running show/formatting callbacks set in
            // the parent controller can run without looping through all the columns
            // every time.
            //
            this.$scope.$watch(( ) => {
                return that.columns;
            }, (columns: any) => {

                if (columns && columns.length) {

                    (columns || [ ]).map( ( column: any ) => {
                        that.dataMap[column.field]       = column;
                        that.dataMap[column.field].index = columnIndex++;
                    });

                    that.gridColumnOrderedKeys = Object.keys(that.dataMap).sort(
                        ( a: any, b: any ) => {
                            return that.dataMap[a].index - that.dataMap[b].index;
                        }
                    );
                }

                that.initializeGridOptions(that.gridConfiguration, columns);
            });

            var columnIndex = 0;
        }

        // Loads data if we have it by rendering the ui-grid component via ng-if,
        //
        private initializeGridResults (gridList: any) : void {

            var that = this;

            if (that.initialized) {
                that.render = true;
                that.populateGrid (gridList);
                if (! gridList.length) {
                    that.setGridOptionsForNoResults();
                }
                else {
                    this.gridContent = this.searchInitTemplate;
                }
            }
        }

        // Data or columns could be set by instantiating controller in either order.
        //
        private initializeGridOptions ( gridConfiguration: any, columns: any[] ) : void {

            if ( ! this.gridOptions.columnDefs
                 || ! this.gridOptions.columnDefs.length
                 || columns.length !== this.gridOptions.columnDefs.length
               ) {

                this.gridOptions = angular.copy(gridConfiguration);

                angular.extend(this.gridOptions, {
                    columnDefs  : this.getGridHeadersForResults(),
                    data        : [ ]
                });
            }

            this.initialized = true;
        }


        // Do any modification to individual column configurations based on the passed-in column
        // definitions.
        //
        private getGridHeadersForResults () : void {

            var that = this;

            var headers = this.gridColumnOrderedKeys.map( (columnKey: any ) => {

                var column: any = that.dataMap[columnKey];

                // Fire off the showCallbacks on the columns for the ones whose visibility
                // are conditional.
                //
                angular.extend(column, {
                    visible: typeof column.showCallback === 'function' ?
                        column.showCallback(column) : column.visible
                });

                // Can we render HTML data in a cell if we want to?  You bet your sweet ass we can!
                //
                if (column.renderHtml) {
                    column.cellTemplate = '<div class="ui-grid-cell-contents" ng-bind-html="row.entity[col.field]"></div>';
                }

                return column;
            });

            return headers;
        }

        // Loading, show the spinny template.
        //
        private setGridOptionsForLoading () : void {
            //this.render = false;
            this.gridContent = 'dealerware-ui-grid/search-results-loading';
        }


        // Show no results template if appropriate.
        //
        private setGridOptionsForNoResults () : void {
            this.gridContent = 'dealerware-ui-grid/search-results-none';
        }


        // Show no results template if appropriate.
        //
        private setGridOptionsForError () : void {
            this.render = false;
            this.gridContent = 'dealerware-ui-grid/search-results-error';
        }

        // Given one-to-one or one-to-many mappings.
        //
        private mapGridData (objectsToBeMapped: any[]) : any[] {

            var that = this;

            return objectsToBeMapped.map ( (obj : any) => {

                var mappedObj: any = { };

                Object.keys(obj).map ( (key : string) => {

                    var gridExtraMappingKeyOrKeys: any = that.mapping[key] !== undefined ? that.mapping[key] : key;

                    // Normal straight-up mapping to just one other key.
                    //
                    if (typeof gridExtraMappingKeyOrKeys === 'string') {
                        mappedObj[gridExtraMappingKeyOrKeys] = obj[key];
                    }
                    // Perhaps we want the same value mapped to multiple keys?
                    // This allows one to stay pristine for purposes of sorting,
                    // and the other to have a display value, e.g. a linked one.
                    //
                    else {
                        gridExtraMappingKeyOrKeys.map( ( mapEachKey : string ) => {
                            mappedObj[mapEachKey] = obj[key];
                        });
                    }

                    // Transfer value to same-named key, unless we already did it above because
                    // there were no alternate mappings.

                    if (mappedObj[key] === undefined) {
                        mappedObj[key] = obj[key];
                    }
                });

                return mappedObj;
            });
        }

        private getFormattedGridData ( rows: any[], columns?: any[] ) : any[] {

            rows = this.mapGridData(rows);

            var formatCallbacks: any = { };

            (columns || this.gridOptions.columnDefs).forEach( ( column: any ) => {

                formatCallbacks[column.field] = typeof column.formatCallback === 'function' ?
                    column.formatCallback : ( v: any ) => {
                        return v;
                    };
            });

            return rows.map( (val : any) => {

                Object.keys(val).forEach((key: any) => {

                    // Call formatFn in the context of the entire record in case
                    // other datapoints need to be used to format this particular
                    // datapoint.
                    //
                    // Columns without specific formatCallback functions use val[key] to
                    // populate the column value.  Those with said callbacks can use the
                    // calling scope, which is the entire row object, to display values
                    // based on the column value or other fields (such as showing a VIN
                    // string as a hyperlink containing that vehicle's id).
                    //
                    val[key] = (
                    formatCallbacks[key] || function (val : any) {
                        return val;
                    }).call(val, val[key]);
                });

                return val;
            });
        }

        // If formatCallback defined, use that to transmogrify the value,
        // otherwise, use a no-op formatter.
        //
        private populateGrid ( data: any ) : void {
            this.gridOptions.data = this.getFormattedGridData (data);
        }

        // Returns all params needed for the ng-csv component to do it's bidness,
        //
        private csvExportParameters ( exportTypeCallbackString: string ) : any {

            var that = this;

            var config = that.csvExport &&
            that.csvExport[exportTypeCallbackString];

            // Special CSV export not configured for this report, or not configured for type
            // AllPages / ThisPage.
            //
            if (! config) {
                return;
            }

            return {

                // Returns the promise ng-csv wants for its main exporting method, which when
                // resolved triggers the .csv download initiated by that component.
                //
                onExport: ( ( ) => {

                    if (config.dataLoadMethod && this.parentControllerAs) {

                        return config.dataLoadMethod.call(
                            that.findParentController(that.$scope, that.parentControllerAs)
                        )
                        .then( ( exportResponseData: any ) => {

                            var rows    = angular.isArray (exportResponseData) ?
                                exportResponseData : exportResponseData.rows;
                            var columns = exportResponseData.columns;

                            return that.getFormattedGridData (rows, columns)
                                .map( ( row: any ) => {
                                    var exportRow: any = { };

                                    (columns || that.gridOptions.columnDefs).forEach( ( column: any ) => {
                                        exportRow[column.field] = that.calculateCsvValue(
                                            row[column.field], row, { colDef: column }
                                        );
                                    });

                                    return exportRow;
                                });
                        });
                    }
                }),

                // Callback for csv-header attribute of ng-csv, to get the csv headers obviously.
                //
                headers: ( ( ) => {

                    // Get headers with promise-based (and therefore asynchronously enabled)
                    // custom method.
                    //
                    if (config.headersLoadMethod && this.parentControllerAs) {
                        return config.headersLoadMethod.call(
                            that.findParentController(that.$scope, that.parentControllerAs)
                        )
                            .then( ( headers: string[] ) => {
                                return headers;
                            });
                    }
                    else {
                        // Just return the same columns as are in the display grid itself.
                        //
                        return that.gridOptions.columnDefs.map ( ( header: any ) => {
                            return header.name;
                        });
                    }
                }),

                // Callback for the name of the csv file to download from the browser, even more
                // obviously.
                //
                filename: ( ( ) => {
                    return config.fileName;
                })
            };
        }

        // Wow.  What a mousetrap this is.
        //
        private findParentController ( $scope: any, scopeString: string ) : ng.IScope {

            var scope = $scope.$parent;
            scopeString.split('.').forEach( ( scopePieceString: string ) => {
                scope = scope[scopePieceString];
            });
            return scope;
        }

        // This does more than return the filters based on the grid column native filter values:
        // its side-effect is that it will clean up filters that have been set and cleared to pristine
        // values, whereas the grid, left to its own devices, will just leave the column filter data
        // touched.  It needs to look untouched for clearFilter to consistently do its job without
        // being fugly code.
        //
        private calculateFilter ( columns : any[] ) : any {

            var filters: any = { };

            columns.forEach( ( column: any ) => {

                if (column.filters[0].term !== undefined) {

                    // Null indicates a former filter value that has now been blanked, and
                    // we don't want to do a simple || because '0' is a legit filter.
                    //
                    filters[column.field] = column.filters[0].term === '' ? null : column.filters[0].term;
                }
            });

            return filters;
        }

        // Straight up ui-grid exports go through this logic via the method up in grid config,
        // but if we're doing custom csv exports, which should be all of the time now, we can
        // call it on the controller itself, in order to do the transformations outside of
        // grid logic.
        //
        private calculateCsvValue ( value: any, row: any, col: any ) {

            // Get rid of any HTML tags added during formatCallback, for all fields.
            // This is kind of a hack to just blast all the cell values with this regexp.
            //
            // And as a hack, it doesn't always work, especially if the formatted value is more than
            // just a simple string as the contents of a tag, e.g. as an icon symbol.  So return the
            // original, formatted value for special parsing in the exporterFieldCallback.
            //
            var unmungedValue = value;
            value = value === null || value === undefined ? '' :
                (value + '').replace(/<[^>]*>([^<]*)(?:<\/[^>]*>)?/g, '$1');

            // Custom exporter formatter callback per-field.
            //
            if (col.colDef.exporterFieldCallback) {
                value = col.colDef.exporterFieldCallback (value, unmungedValue, row, col.colDef);
            }

            return value;
        }

        private toggleResultsExpansion () : void {

            this.initializeGridResults (this.getDisplayCollection());
        }

        public getDisplayCollection () : any[] {

            var that = this;

            return (that.$scope.G.collapseExpandItemCount && ! that.gridCollapsed
                ? that.collection.data.slice(0, that.$scope.G.collapseExpandItemCount)
                : that.collection.data
            ).map( (object: any ) => {
                return object.data || object;
            });
        }
    }

    getDealerwareWebComponentsModule().controller('UiGridDirectiveController', UiGridDirectiveController);

    export class UiGridDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'UiGridDirectiveController';
        public controllerAs     : string    =   'G'; // 'G' is for 'Grid'
        public bindToController : boolean   =   true;
        public scope            : Object    =   {
            list                     : '=?',
            collection               : '=?',
            columns                  : '=',
            loading                  : '=?',
            error                    : '=?',
            mapping                  : '=?',
            enableFiltering          : '=?',
            serverSidePageSortFilter : '=?',
            onSort                   : '=?',
            onFilter                 : '=?',
            onClearSortAndFilter     : '=?',
            onClearFilter            : '=?',
            csvExport                : '=?csvExportConfiguration',
            pager                    : '=?pagerConfiguration',
            parentControllerAs       : '@?',
            noDataInitMessage        : '@?',
            noDataEmptyMessage       : '=?',
            errorMessage             : '@?',
            initialCollapse          : '=?',
            collapseExpandItemCount  : '=?'
        };
        public templateUrl      : string    =   '/components/grid/ui-grid-directive.html';
    }

    getDealerwareWebComponentsModule().directive('dealerwareUiGrid', ( ) => new UiGridDirective());
}
